import React, { useState } from "react";
import { Box } from "@mui/material";
import ContactNavigation from "../components/ContactNavigation";
import ContactListView from "./ContactListView";
import GroupView from "./GroupView";

const ContactView = () => {
  const [activeSection, setActiveSection] = useState("contacts");

  const handleSectionChange = (sectionId) => {
    setActiveSection(sectionId);
  };

  const renderDetailView = () => {
    switch (activeSection) {
      case "contacts":
        return <ContactListView />;
      case "group":
        return <GroupView />;
      default:
        return <ContactListView />;
    }
  };

  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%" }}>
      {/* Left Column: Navigation Panel (25%) */}
      {/* <Box sx={{  width: { xs: "100%", md: "20%" },
          minWidth: { xs: 0, md: 240 } }}>
        <ContactNavigation
          activeSection={activeSection}
          onSectionChange={handleSectionChange}
        />
      </Box> */}

      {/* Right Column: Detail View (75%) */}
      <Box sx={{ flex: 1, width: "75%" }}>{renderDetailView()}</Box>
    </Box>
  );
};

export default ContactView;
